import { setYear } from 'date-fns';
import * as yup from 'yup';

const glassClaimFormValidationMessages: { [field: string]: string } = {
  nameLength: 'Name must be at least 3 letters with no special characters',
  validName: 'Enter a valid name',
  validPhoneNumber: 'Enter a valid phone number with the area code',
  validEmail: 'Enter a valid email address',
  validDate:
    'Enter a date in MM/DD/YYYY format. Entry cannot be a future date.',
};

export type GlassClaimForm = {
  policyNumber: string;
  incidentDate: Date;
  claimOpener: string;
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  email: string;
  PhoneNumber: string;
};

const today = new Date();
today.setHours(23, 59, 59);

const twentyYearsAgo = setYear(new Date(), 2000);

export const policySelectionFormValidation = yup.object({
  policyNumber: yup.string().required(),
});

export const glassClaimDetailsFormValidation = yup.object({
  incidentDate: yup
    .date()
    .min(twentyYearsAgo, glassClaimFormValidationMessages.validDate)
    .max(today, glassClaimFormValidationMessages.validDate)
    .typeError(glassClaimFormValidationMessages.validDate),
  claimOpener: yup.string().required(),
  firstName: yup
    .string()
    .when('claimOpener', {
      is: 'other',
      then: yup.string().required(glassClaimFormValidationMessages.nameLength),
      otherwise: yup.string().notRequired(),
    })
    .min(3, glassClaimFormValidationMessages.nameLength)
    .matches(/^[a-zA-Z '-]+$/, glassClaimFormValidationMessages.validName),
  lastName: yup
    .string()
    .when('claimOpener', {
      is: 'other',
      then: yup.string().required(glassClaimFormValidationMessages.nameLength),
      otherwise: yup.string().notRequired(),
    })
    .min(3, glassClaimFormValidationMessages.nameLength)
    .matches(/^[a-zA-Z '-]+$/, glassClaimFormValidationMessages.validName),
});

export const glassClaimDriverInfoValidations = yup.object({
  PhoneNumber: yup
    .string()
    .required(glassClaimFormValidationMessages.validPhoneNumber)
    .length(10, glassClaimFormValidationMessages.validPhoneNumber)
    .matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/),
  email: yup
    .string()
    .required(glassClaimFormValidationMessages.validEmail)
    .email(glassClaimFormValidationMessages.validEmail)
    .min(2, glassClaimFormValidationMessages.validEmail)
    .matches(
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    ),
});
